export default "__VITE_ASSET__Dmh04$ue__"